import React, { useContext } from 'react';
import StoreContext from '~/context/StoreContext'
import { TiDelete } from 'react-icons/ti'
import styled from '@emotion/styled'

const ButtonSize = styled(TiDelete)`
    height: 40px;
    width: 40px;

    @media(max-width: 890px){
            height: 30px;
            width: 30px;
    }

    @media(max-width: 678px){
        height: 30px;
        width: 30px;
        font-size: 1.5rem;
    }
`;

const ButtonDelete = styled.button`
    color: #B22222;
    background-color: transparent;
    border: 0;
    margin: 0;
    padding: 0;
    height: 30px;
    width: 30px;

    :hover{
        cursor: pointer;
    }

    @media(max-width: 678px){
        font-size: 1.5rem;
        height: 20px;
        width: 20px;
    }

    @media(max-width: 613px){
        font-size: 1.3rem;
    }
`;

const ItemCart = ({ item }) => {

    const {
        removeLineItem,
        store: { client, checkout },
    } = useContext(StoreContext)

    const variantImage = item.variant.image ? (
        <img
            src={item.variant.image.src}
            alt={`${item.title} product shot`}
            height="60px"
        />
    ) : null

    const selectedOptions = item.variant.selectedOptions
        ? item.variant.selectedOptions.map(
            option => `${option.name}: ${option.value} `
        )
        : null

    const handleRemove = () => {
        removeLineItem(client, checkout.id, item.id)
    }

    return (
        <tr>
            <td>{variantImage}</td>
            <td>{item.title}
                {`  `}
                {item.variant.title === !'Default Title'
                    ? item.variant.title
                    : ''}</td>
            <td>{selectedOptions}</td>
            <td>{item.quantity}</td>
            <td><ButtonDelete onClick={handleRemove}><ButtonSize /></ButtonDelete></td>
        </tr>
    );
}

export default ItemCart;